export const toggleModalCalendar = (
  triggerClassName,
  modalClassName
) => {
  const triggers = document.querySelectorAll(`.${triggerClassName}`);
  const modal = document.querySelector(`.${modalClassName}`);

  if (!triggers.length || !modal) {
    return;
  }

  const backButton = modal.querySelector(".c-button-back");
  let activeTrigger = null;

  // トリガーボタンのクリックイベント
  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      const isExpanded = trigger.getAttribute("aria-expanded") === "true";
      if (isExpanded) {
        closeModal();
        trigger.focus();
      } else {
        activeTrigger = trigger;
        openModal();
      }
    });
  });

  const openModal = () => {
    triggers.forEach((t) => {
      t.setAttribute("aria-expanded", "true");
      t.setAttribute("aria-label", "メンバー用カレンダーを閉じる");
    });
    modal.inert = false;
    document.documentElement.style.overflow = "hidden";
    const firstFocusable = modal.querySelector("a, button");
    if (firstFocusable) {
      firstFocusable.focus();
    }
  };

  const closeModal = () => {
    triggers.forEach((t) => {
      t.setAttribute("aria-expanded", "false");
      t.setAttribute("aria-label", "メンバー用カレンダーを開く");
    });
    modal.inert = true;
    document.documentElement.style.overflow = "";
  };

  // 戻るボタンで閉じる
  if (backButton) {
    backButton.addEventListener("click", () => {
      closeModal();
      if (activeTrigger) {
        activeTrigger.focus();
      }
    });
  }

  // Escapeキーでモーダルを閉じる
  document.addEventListener("keydown", (e) => {
    const isOpen = Array.from(triggers).some(
      (t) => t.getAttribute("aria-expanded") === "true"
    );
    if (e.key === "Escape" && isOpen) {
      closeModal();
      if (activeTrigger) {
        activeTrigger.focus();
      }
    }
  });

  // 初期状態
  closeModal();
};
